<template>
	<div>
		<div class="actions mb-3">
			<b-button class="actions__item" variant="primary" @click="addParticipantBtnHandler"><i class="fa fa-plus"></i> Добавить участника</b-button>
			<div class="actions__item"><span class="badge badge-success">{{ numberMembers }}</span> количество участников</div>
		</div>
		<vuetable ref="vuetable"
			:fields="columns"
			:api-mode="false"
			:data="tableData"
			@vuetable:row-dblclicked="rowClickHandler"
			class="table-striped table-payment"
			noDataTemplate="Ничего не найдено">
				<template slot="fio" slot-scope="props">
					{{ props.rowData.last_name }} {{ props.rowData.first_name }} {{ props.rowData.middle_name }}
				</template>
				<template slot="actions" slot-scope="props">
					<div class="custom-actions">
						<b-button variant="danger" @click="deleteMemberHandler(props.rowData, props.rowIndex)"><i class="fa fa-trash"></i> Удалить</b-button>
					</div>
			</template>
		</vuetable>

		<b-modal v-model="addMemberModal" @hidden="hideHandler" @ok="sendHandler" size="lg" cancel-title="Отмена" ok-title="Создать" title="Добавить участника">
			<b-form ref="form">
				<div class="row">
					<div class="col-md-6">
						<b-form-group label="Имя" label-for="firstName" class="is-required" :class="{ 'has-error': $v.form.firstName.$error }">
							<b-form-input id="firstName" v-model.trim="form.firstName" placeholder="Имя"></b-form-input>
							<small class="invalid-feedback" v-if="$v.form.firstName.$error">Только буквы, пробелы и тире. Минимальная длина: 2 символа.</small>
						</b-form-group>

						<b-form-group label="Фамилия" label-for="lastName" class="mb-2 is-required" :class="{ 'has-error': $v.form.lastName.$error }">
							<b-form-input id="lastName"  :disabled="parseInt(isExcludeLastName) === 1" v-model.trim="form.lastName" placeholder="Фамилия"></b-form-input>
							<small class="invalid-feedback" v-if="$v.form.lastName.$error">Только буквы, пробелы и тире. Минимальная длина: 2 символа.</small>
						</b-form-group>

						<b-form-group>
							<b-form-checkbox value="1" v-model="isExcludeLastName" unchecked-value="0">Без фамилии</b-form-checkbox>
						</b-form-group>

						<b-form-group label="Отчество" label-for="middleName" class="mb-2 is-required" :class="{ 'has-error': $v.form.middleName.$error }">
							<b-form-input id="middleName" :disabled="parseInt(isExcludeMiddleName) === 1" v-model.trim="form.middleName" placeholder="Отчество"></b-form-input>
							<small class="invalid-feedback" v-if="$v.form.middleName.$error">Только буквы, пробелы и тире. Минимальная длина: 2 символа.</small>
						</b-form-group>

						<b-form-group>
							<b-form-checkbox value="1" v-model="isExcludeMiddleName" unchecked-value="0">Без отчества</b-form-checkbox>
						</b-form-group>
					</div>

					<div class="col-md-6">
						<b-form-group label="Категория" label-for="email" :class="{ 'has-error': $v.form.packetType.$error }">
							<b-form-select class="form-control" v-model="form.packetType" :options="packets"></b-form-select>
							<small class="invalid-feedback" v-if="$v.form.packetType.$error">Выберите категорию.</small>
						</b-form-group>
						<b-form-group label="Адрес электронной почты" label-for="email" :class="{ 'has-error': $v.form.email.$error }">
							<b-form-input id="email" v-model.trim="form.email" placeholder="youare@awesome.ru"></b-form-input>
						</b-form-group>

						<b-form-group label="Номер телефона" label-for="phone">
							<masked-input class="el-input__inner" id="phone" v-model="form.phone" mask="\+\7 (111) 111-11-11" placeholder="+7 (495) 123-45-67" />
						</b-form-group>
					</div>
				</div>
			</b-form>
		</b-modal>
	</div>
</template>
<script>
import { required, email, minLength, helpers } from 'vuelidate/lib/validators'
import MaskedInput from 'vue-masked-input'
import memberAPI from '@/api/modules/payment/member'

const onlyLettersAndDashes = helpers.regex('alpha', /^[A-ZА-ЯЁ\s-]*$/i)

export default {
	components: {
		MaskedInput
	},
	data: function () {
		return {
			addMemberModal: false,
			numberMembers: 0,
			members: [],
			tableData: [],
			tableDataKey: null,
			form: {
				key: '',
				id: '',
				firstName: '',
				lastName: '',
				middleName: '',
				packetType: '',
				email: '',
				phone: ''
			},
			oldLastName: '',
			isExcludeLastName: '',
			oldMiddleName: '',
			isExcludeMiddleName: '',
			packets: [
				{value: 1, text: 'Стандарт'},
				{value: 2, text: 'Бизнес'},
				{value: 3, text: 'Вип'}
			],
			columns: [
				{
					name: 'id',
					title: '#'
				}, {
					name: '__slot:fio',
					title: 'ФИО'
				}, {
					name: 'email',
					title: 'Адрес электронной почты'
				}, {
					name: 'phone',
					title: 'Номер телефона'
				}, {
					name: '__slot:actions',
					title: 'Действия',
					titleClass: 'center aligned',
					dataClass: 'center aligned'
				}
			]
		}
	},
	validations: {
		form: {
			firstName: {
				required,
				minLength: minLength(2),
				onlyLettersAndDashes
			},
			lastName: {
				required,
				minLength: minLength(2),
				onlyLettersAndDashes
			},
			middleName: {
				required,
				minLength: minLength(2),
				onlyLettersAndDashes
			},
			packetType: {
				required
			},
			email: {
				email
			}
		}
	},
	props: {
		id: {
			type: Number,
			required: true
		}
	},
	created () {
		this.buildMemberList()
		this.$notify({
			group: 'warning',
			title: 'Поздравляем!',
			text: 'Данные успешно сохранены.'
		})
	},
	methods: {
		buildMemberList () {
			memberAPI.findAll({payment_id: this.id}).then((result) => {
				this.members = result
				this.tableData = result
			})
		},
		hideHandler () {
			// this.$emit('hide')
		},
		rowClickHandler (row, event) {
			let member = {}
			this.members.forEach((value, key) => {
				if (value.id === row.id) {
					this.tableDataKey = key
					member = value
				} else {
					return false
				}
			})
			this.form = {
				key: row.id,
				id: member.id,
				firstName: member.first_name,
				lastName: member.last_name,
				middleName: member.middle_name,
				packetType: member.packet_type,
				email: member.email,
				phone: this.formatPhone(member.phone)
			}
			this.toggleDialog()
		},
		addParticipantBtnHandler () {
			this.toggleDialog()
		},
		dialogClose (formName) {
			this.clearForm(formName)
			this.clearValidate(formName)
			this.addMemberModal = false
		},
		clearForm (formName) {
			this.$refs[formName].resetFields()
			this.form = {}
		},
		clearValidate (formName) {
			this.$refs[formName].clearValidate()
		},
		sendHandler (e) {
			e.preventDefault()
			// this.$v.$reset()
			this.$v.$touch()
			if (this.$v.$invalid) {
				return false
			}

			let data = this.form

			if (data.id > 0) {
				memberAPI.update(data.id, data).then((result) => {
					if (this.tableDataKey >= 0) {
						this.members[this.tableDataKey] = result
						this.$v.form.$reset()
						this.form = {}
						this.addMemberModal = false
					}
				})
			} else {
				memberAPI.create(this.id, data).then((result) => {
					this.$v.form.$reset()
					this.form = {}
					this.addMemberModal = false
					this.members.push(result)
				})
			}
		},
		deleteMemberHandler (rowData, rowIndex) {
			this.$dialog.confirm('Вы действительно хотите удалить участника?').then(() => {
				memberAPI.delete(rowData.id).then((result) => {
					if (this.tableDataKey >= 0) {
						this.members.splice(this.tableDataKey, 1)
					}
				})
			}).catch(() => {})
		},
		formatPhone (phone) {
			if (phone.length > 10) {
				return phone.replace(/[^0-9]/g, '').slice(-10)
			}

			return null
		},
		toggleDialog () {
			this.addMemberModal = !this.addMemberModal
		}
	},
	watch: {
		isExcludeLastName: function (value) {
			this.form.lastName = parseInt(value) === 0 ? this.oldLastName : 'не указано'
		},
		'form.lastName': function (value, oldValue) {
			if (value === 'не указано') {
				this.isExcludeLastName = 1
			}

			this.oldLastName = oldValue
		},
		isExcludeMiddleName: function (value) {
			this.form.middleName = parseInt(value) === 0 ? this.oldMiddleName : 'не указано'
		},
		'form.middleName': function (value, oldValue) {
			if (value === 'не указано') {
				this.isExcludeMiddleName = 1
			}

			this.oldMiddleName = oldValue
		},
		members: function (value) {
			this.numberMembers = value.length
		}
	}
}
</script>
<style lang="scss" scoped>
.actions {
	display: flex;
	align-items: center;
	&__item {
		margin-left: 1rem;
		&:first-child { margin-left: 0; }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/payment/update/participant.vue